module.exports = {
    // basic
    'show-entry-types-title': 'show entry types',
    'show-entry-types-with-notifications': 'with notifications',
    'show-entry-types-all': 'all',
    'email-with-file': 'email with file',
    'notification-type': 'notification type',
    'text': 'text',
    'doc-approval-alert-entry-uploaded': 'entry uploaded',
    'doc-approval-alert-step': 'document approval steps',
    'doc-approval-alert-fully-approved': 'entry fully approved',
    'doc-approval-alert-rejected': 'entry rejected',
    'specific-wells': 'specific wells',
    'specific-well-groups': 'specific well groups',
    'specific-rigs': 'specific rigs',
    'specific-assets': 'specific assets',
    'all-wells': 'all wells',
    'show-entry-types-without-notifications': 'show entry types without notifications',
    'active-on': 'active On',
    'doc-approval-options': 'document approval options',
    'set-multiple-notifications': 'set multiple notifications',
    'system': 'system',
    'paused': 'paused',
    'active': 'active',

    // raw
    'alerts-saved': 'Notification setting saved.',
    'delete-all-alerts': 'This will delete all notifications from all entry types on all wells. Are you sure?',
    'selected-well-alerts': 'the selected wells',
    'selected-rig-alerts': 'the selected rigs',
    'selected-asset-alerts': 'the selected assets',
    'all-well-alerts': 'all wells',
    'max-attachment-size-help': 'If the total size of all files in an entry is greater than the limit, the files will still be attached, but on multiple emails.  Any single file greater than the limit will not be attached to any email, and must be downloaded from the website.',
    'alert-status-master': 'The selected notification types (above) will be sent for this entry type <b>on all wells.</b>',
    'alert-status-asset': 'The selected notification types (above) will be sent for this entry type <b>only on wells with the selected assets.</b>',
    'alert-status-rig': 'The selected notification types (above) will be sent for this entry type <b>only on wells with the selected rigs.</b>',
    'alert-status-well': 'The selected notification types (above) will be sent for this entry type <b>only on the selected wells.</b>',
    'alert-status-well-group': 'The selected notification types (above) will be sent for this entry type <b>only on the selected well groups.</b>',
    'doc-approval-alert-desc': 'Document approval notifications are only delivered via email, with no attachments.',
    'doc-approval-alert-entry-uploaded-desc': 'This will send a notification whenever a new document approval entry is uploaded.',
    'doc-approval-alert-step-desc': 'This will send a notification whenever the selected document approval steps are approved or unapproved.',
    'doc-approval-alert-fully-approved-desc': 'This will send a notification whenever all steps have been approved.',
    'doc-approval-alert-rejected-desc': 'This will send a notification whenever the entry is rejected.',
    'multi-alerts-desc': 'Quickly apply changes to notification preferences across multiple entry types, and multiple assets, rigs or wells.',
    'alert-on-desc': 'Notifications will be sent according to the preferences you have set.',
    'alert-off-desc': 'Notifications will not be sent.  You can still edit your preferences if you wish.',
    'pause-all-notifications': 'Pause All Notifications',
    'attachment-size-limit': 'MB limit',
    'all-notifications-paused': 'ALL NOTIFICATIONS PAUSED',

    // template
    'sms-alert-help': (words) => `To select Text alerts, you must provide both a cell number and a cell carrier in <a id="myAccountBtn" href="#myAccount/${words[0]}">My Account</a>.`,
    'edit-notifications': (words) => `Edit "${words[0]}" Notifications`,
    'edit-doc-approval-notifications': (words) => `Edit "${words[0]}" Document Approval Notifications`,
    'add-alerts': (words) => `This will add the selected notification type to the selected entry types on ${words[0]}. Are you sure?`,
    'batch-edit-alerts': () => `This will change the notification preferences (for this company's entry types) of all selected users to the options and limits selected above.  \r\nContinue?`,
    'batch-delete-alets': () => `This will delete all notification preferences (for this company's entry types) of all selected users.\r\nContinue?`,
    'delete-alerts': (words) => `This will delete the selected notification type from the selected entry types on ${words[0]}. Are you sure?`,
    'alert-edit-confirm': (words) => `
        You have chosen to limit Notifications to specific ${words[0]}, but no ${words[1]} selections have been made.</br>
        If you still want to limit to specific ${words[0]}, click <b>Cancel</b> and select one or more ${words[0]} before clicking <b>Save</b>.</br>
        Or, click <b>Ok</b> to continue saving with the option set to <b>All Wells</b>.
    `,
    'alert-paused': (words) => `Notification "${words[0]}" is paused.`,
    'alert-resumed': (words) => `Notification "${words[0]}" is active.`,
};
